import { ANALYTICS_PARAMS_BANLIST } from '@mote/helpers/constants'
import { noLog as log } from '../shared/Utils'
import { DiagnosticsLogger } from '@mote/helpers/diagnostics'
import ky from 'ky'
import { API_BASE_URL } from '@mote/config/constants'
import { snakify } from '@mote/helpers/misc'

// needs to be like this to avoid circular dependency
import { getUserIdMaybeAnonymous } from '@mote/helpers/identity/getOrMakeAnonymousUserId'
import { canAccessWebLocalStorage } from '@mote/helpers/browser'

export const apiClient = ky.extend({
  prefixUrl: API_BASE_URL,
  timeout: 12000
})

const logD = new DiagnosticsLogger('WebAnalytics')

const REFERRER_KEY = 'mote_referrer_user_id'

function getReferrer() {
  if (!canAccessWebLocalStorage()) return ''

  return window.localStorage.getItem(REFERRER_KEY)
}

function postErrorEvent(title, key, text, tags) {
  var default_tags = ['web:1', 'user_visible_error:1', key + ':1']
  if (!tags) {
    tags = []
  }
  var output_tags = default_tags.concat(tags)
  text += '\n\nCurrent URL: ' + window.location.href
  const o = { title: title, key: key, text: text, tags: output_tags }

  log('Going to send: ' + title + ' -> ' + text, o)
  try {
    var url = window.location.href.toLowerCase()
    if (url.includes('http://loc')) {
      log(
        'Oops, sending this error to Segment and Datadog would be too noisy (as we are on loc)'
      )
      return
    }
  } catch (e) {
    console.error('Errored trying to parse URL: ', e)
  }
  track('Error Seen on Web: ' + title, {
    error_key: key,
    error_text: text
  })

  apiClient
    .post('d/error', { json: o })
    .then(_ => log('Successfully sent error event: ', o))
    .catch(e => console.error('Could not send error event: ', o, e))
}

export const identify = (userId, o) => {
  var direct = bypassSegment()
  const oo = enrichTrackingData(safeAnalyticsData(o), direct)
  if (direct) {
    const ooo = Object.assign(oo, { userId: userId })
    apiClient
      .post('s/identify/everything', { json: ooo })
      .catch(e => console.error('Failed to send analytics', e, ooo))
  } else if (window.analytics) {
    window.analytics.identify(o.userId, oo)
  } else {
    console.error('no way to send analytics data: ', oo)
  }
}

export const track = async (event, o) => {
  if (!o) {
    o = {}
  }
  o['page_context'] = window.location.href

  var direct = bypassSegment()
  const oo = enrichTrackingData(safeAnalyticsData(o), direct)
  const userId = getUserIdMaybeAnonymous()
  oo['userId'] = userId
  if (direct) {
    const ooo = Object.assign({ event: event }, oo)
    logD.info(`[TRACKING.web] ${event}`, ooo)

    try {
      await apiClient.post('s/track/everything', { json: ooo })
    } catch (e) {
      console.error('Failed to track analytics', e, ooo)
    }
  } else if (window.analytics) {
    window.analytics.track(event, oo)
  } else {
    console.error('no way to send analytics data: ', oo)
  }
}

function bypassSegment() {
  return true
}

function enrichTrackingData(o, direct) {
  var oo = Object.assign({}, o)
  oo['tracking_source'] = 'website'
  if (direct) {
    oo['tracking_route'] = 'direct'
  } else {
    oo['tracking_route'] = 'segment'
  }
  return oo
}

function safeAnalyticsData(o) {
  // log("Received: ", o);
  var oo = Object.assign({}, o)
  for (const key of ANALYTICS_PARAMS_BANLIST) {
    if (key in oo) {
      oo[key] = undefined
    }
  }
  if (oo.primaryEmailAddress) {
    const email = oo.primaryEmailAddress
    oo.primaryEmailAddress = undefined
    oo['email'] = email
    const atSymbolIndex = email.indexOf('@')
    if (atSymbolIndex > 0 && email.length > atSymbolIndex + 1) {
      oo['email_domain'] = email
        .slice(atSymbolIndex + 1, email.length)
        .toLowerCase()
    }
  }
  if (
    oo.isMinor === true ||
    oo.isMinor === 'true' ||
    oo.isMinor === 'True' ||
    oo.isMinor === '1' ||
    oo.isMinor === 1
  ) {
    oo.isMinor = '1'
  } else {
    oo.isMinor = '0'
  }
  // log("Sending to snake_case: ", oo);
  return snakify(oo)
}

export { getReferrer, postErrorEvent }
